// extracted by mini-css-extract-plugin
export default {"notice":"DetailsPayProcess_notice__4hkT5","transfer":"DetailsPayProcess_transfer__DgcwG"};